import React from 'react'


interface AsoleacionVideo {
    currentVideo: any
}

interface Props{
    isAsoleacionActive: boolean,
    currentVideoSelected: string,
    asoleacionAutoplay: boolean,
    handleGetCurrentVideoDuration: any,
    handleUpdateBar: any
}

interface State{}

class AsoleacionVideo extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }

        this.currentVideo = React.createRef()
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isAsoleacionActive ? "asoleacion-video-container fade-in":"asoleacion-video-container fade-out"}>
                {
                    this.props.isAsoleacionActive ?
                    <video 
                        ref = {this.currentVideo}
                        playsInline 
                        preload='auto' 
                        id="video" 
                        src={this.props.currentVideoSelected}
                        muted={true}
                        loop={false}
                        autoPlay={this.props.asoleacionAutoplay}
                        onLoadedMetadata = {() => {this.props.handleGetCurrentVideoDuration()}}
                        onTimeUpdate = {() => {this.props.handleUpdateBar()}}
                    />:null
                }
            </div>
        )
    }
}

export default AsoleacionVideo